module.exports = __webpack_public_path__ + "static/media/card_brand_amex.75317e5f.svg";